export const MISSING_IMAGE_URL = 'https://images.basketful.co/missingItem.png';
export const SMART_COMMERCE_ORANGE = '#f26b21';
export const SMART_COMMERCE_PURPLE = '#252a61';
export const SMART_COMMERCE_PRIVACY_POLICY_URL =
  'https://smartcommerce.com/privacy-policy/';
